import React from "react";
import { Star } from "lucide-react";
export const Testimonials = () => {
  return <div className="py-20 bg-white" data-id="element-1482">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1483">
        <div className="text-center mb-16" data-id="element-1484">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-1485">
            Proven Results, Now Powered by AI
          </h2>
          <p className="text-xl text-gray-600" data-id="element-1486">
            Our expertise helped scale 40+ businesses. Now it's built into every
            campaign.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1487">
          <TestimonialCard name="Alex Rivera" role="Growth Manager" company="CloudTech Solutions" image="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e" text="The chat interface is brilliant. I described our ideal customer, and Gigi found 100+ perfect prospects in minutes. Game changer for our outreach." data-id="element-1488" />
          <TestimonialCard name="Lisa Chen" role="Marketing Lead" company="DataFlow AI" image="https://images.unsplash.com/photo-1494790108377-be9c29b29330" text="Love how Gigi personalizes each message. Our response rates jumped 40% in the first week. The AI really understands each prospect's profile." data-id="element-1489" />
          <TestimonialCard name="James Wilson" role="Sales Director" company="TechStart" image="https://images.unsplash.com/photo-1519345182560-3f2917c472ef" text="Finally, an AI tool that gets B2B outreach. Set up our first campaign in 10 minutes, and the quality of conversations has been outstanding." data-id="element-1490" />
        </div>
      </div>
    </div>;
};
const TestimonialCard = ({
  name,
  role,
  company,
  image,
  text
}) => <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-200 transform hover:scale-105 transition-transform duration-300" data-id="element-1491">
    <div className="flex gap-1 mb-4" data-id="element-1492">
      {[...Array(5)].map((_, i) => <Star key={i} size={20} className="fill-[#6366f1] text-[#6366f1]" data-id="element-1493" />)}
    </div>
    <p className="text-gray-600 mb-6" data-id="element-1494">{text}</p>
    <div className="flex items-center" data-id="element-1495">
      <img src={image} alt={name} className="w-12 h-12 rounded-full object-cover mr-4" data-id="element-1496" />
      <div data-id="element-1497">
        <div className="font-semibold text-gray-900" data-id="element-1498">{name}</div>
        <div className="text-sm text-[#6366f1]" data-id="element-1499">
          {role}, {company}
        </div>
      </div>
    </div>
  </div>;